import { useMemo } from "react";
import useCurrencies from "../../hooks/useCurrencies";
import FastTable, { TABLE_TYPES } from "../FastTable/FastTable";
import { TX_TYPES } from "../../constants";

export default function UserNFCData({ basicUser, txs }) {
  const { currencies, paymentMethods } = useCurrencies();

  const user = useMemo(() => {
    const found = basicUser;
    if (found) {
      const userCurrencies = currencies.map((currency) => {
        const currIdKey = Object.keys(found).find(
          (key) =>
            /^currencyid\d$/.test(key) && found[key] === currency.currencyid
        );
        if (currIdKey) {
          const currencyIndex = parseInt(currIdKey.replace("currencyid", ""));
          if (currencyIndex) {
            if (currency.name !== "Cortesía" && currency.name !== "Depósito") {
              const pesosTransactions = txs.filter(tx =>
                tx.currencyid === currency.currencyid &&
                (tx.type === TX_TYPES.topUp.value ||
                  tx.type === TX_TYPES.init.value ||
                  tx.type === TX_TYPES.refund.value)
              );

              const cashTransactions = pesosTransactions.filter(tx => tx.paymentmethodid === paymentMethods.find(pm => pm.name.toLowerCase() === "efectivo")?.paymentmethodid);
              const cardTransactions = pesosTransactions.filter(tx => tx.paymentmethodid === paymentMethods.find(pm => pm.name.toLowerCase() === "tarjeta")?.paymentmethodid);
              const precargaTransactions = pesosTransactions.filter(tx => tx.paymentmethodid === paymentMethods.find(pm => pm.name.toLowerCase() === "precarga")?.paymentmethodid);

              const cashBalance = cashTransactions
                .reduce((acc, tx) => acc + parseFloat(tx.amount), 0);

              const cardBalance = cardTransactions
                .reduce((acc, tx) => acc + parseFloat(tx.amount), 0);

              const precargaBalance = precargaTransactions
                .reduce((acc, tx) => acc + parseFloat(tx.amount), 0);


              const salesTransactions = txs.filter(tx =>
                tx.currencyid === currency.currencyid &&
                (
                  tx.type === TX_TYPES.sale.value ||
                  tx.type === TX_TYPES.return.value
                )
              );

              const totalSales = salesTransactions.reduce((acc, tx) => acc + parseFloat(tx.amount), 0);

              let remainingSales = totalSales;
              let finalCashBalance = cashBalance;
              let finalCardBalance = cardBalance;
              let finalPrecargaBalance = precargaBalance;

              let isAnyCashTxNotVerified = cashTransactions.some(tx => tx.verified === "0");
              let isAnyCardTxNotVerified = cardTransactions.some(tx => tx.verified === "0");
              let isAnyPrecargaTxNotVerified = precargaTransactions.some(tx => tx.verified === "0");
              let isAnySaleTxNotVerified = salesTransactions.some(tx => tx.verified === "0");

              if (remainingSales > 0) {
                if (finalCashBalance >= remainingSales) {
                  finalCashBalance -= remainingSales;
                  remainingSales = 0;
                  isAnyCashTxNotVerified = isAnyCashTxNotVerified || isAnySaleTxNotVerified;
                } else if (finalPrecargaBalance >= remainingSales) {
                  finalPrecargaBalance -= remainingSales;
                  remainingSales = 0;
                  isAnyPrecargaTxNotVerified = isAnyPrecargaTxNotVerified || isAnySaleTxNotVerified;
                } else {
                  remainingSales -= finalCashBalance;
                  finalCashBalance = 0;
                }
              }

              if (remainingSales > 0) {
                finalCardBalance = finalCardBalance - remainingSales;
                isAnyCardTxNotVerified = isAnyCardTxNotVerified || isAnySaleTxNotVerified;
              }

              return [
                {
                  ...currency,
                  name: currency.name + " Efectivo",
                  balance: finalCashBalance,
                  date: found[`date${currencyIndex}`],
                  userid: found[`userid${currencyIndex}`],
                  deviceid: found[`deviceid${currencyIndex}`],
                  verified: !isAnyCashTxNotVerified,
                },
                {
                  ...currency,
                  name: currency.name + " Tarjeta",
                  balance: finalCardBalance,
                  date: found[`date${currencyIndex}`],
                  userid: found[`userid${currencyIndex}`],
                  deviceid: found[`deviceid${currencyIndex}`],
                  verified: !isAnyCardTxNotVerified,
                },
                {
                  ...currency,
                  name: currency.name + " Precarga",
                  balance: finalPrecargaBalance,
                  date: found[`date${currencyIndex}`],
                  userid: found[`userid${currencyIndex}`],
                  deviceid: found[`deviceid${currencyIndex}`],
                  verified: !isAnyPrecargaTxNotVerified,
                }
              ];
            } else {
              const isAnyTxNotVerified = txs.some(tx => tx.currencyid === currency.currencyid && tx.verified === "0");
              return {
                ...currency,
                balance: found[`balance${currencyIndex}`],
                date: found[`date${currencyIndex}`],
                userid: found[`userid${currencyIndex}`],
                deviceid: found[`deviceid${currencyIndex}`],
                verified: !isAnyTxNotVerified,
              };
            }
          }
        }
        return { ...currency, balance: 0, verified: true };
      });

      found.currencies = userCurrencies.flat();
    }
    return found;
  }, [basicUser, currencies, txs, paymentMethods]);

  return (<>
    <h2>Estado NFC</h2>
    <FastTable
      data={user?.currencies || []}
      columns={[
        {
          key: "currencyid",
          label: "ID",
          style: { width: 50 },
        },
        {
          key: "name",
          label: "Nombre",
          type: TABLE_TYPES.string,
        },
        {
          key: "balance",
          label: "Balance",
          type: TABLE_TYPES.currency,
          prefix: (row) => (row?.symbol ? row.symbol : "$") + " ",
        },
        {
          key: "date",
          label: "Últ. actualización",
          type: TABLE_TYPES.dateUnix,
        },
        {
          key: "verified",
          label: "Verificado",
          render: (row) => <div style={{ textAlign: "center" }}>{
            row.verified ? "✔️" : "❓"}</div>,
          type: TABLE_TYPES.string,
          filter: true,
          filterType: "includes",
          filterRender: (row) => row.verified ? "✔️" : "❓",
        }
      ]}
      showExcel={false}
      showGroups={false}
      showFilters={false}
      showPagination={false}
    /></>)
}